import { render, staticRenderFns } from "./EmailFormat.vue?vue&type=template&id=0ab12026&scoped=true&lang=pug"
import script from "./EmailFormat.vue?vue&type=script&lang=js"
export * from "./EmailFormat.vue?vue&type=script&lang=js"
import style0 from "./EmailFormat.vue?vue&type=style&index=0&id=0ab12026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab12026",
  null
  
)

export default component.exports